/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { productPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import { labelStyle, valueStyle } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

productPartNumbersStyles.container = {
    gap: 0,
};

productPartNumbersStyles.erpNumberLabelText = {
    css: css`
        ${labelStyle};
    `,
};

productPartNumbersStyles.erpNumberValueText = {
    css: css`
        ${valueStyle};
    `,
};

productPartNumbersStyles.customerNameLabelText = {
    css: css`
        ${labelStyle};
    `,
};

productPartNumbersStyles.customerNameValueText = {
    css: css`
        ${valueStyle};
    `,
};

productPartNumbersStyles.manufacturerItemLabelText = {
    css: css`
        ${labelStyle};
    `,
};

productPartNumbersStyles.manufacturerItemValueText = {
    css: css`
        ${valueStyle};
    `,
};
